import { gql } from '@apollo/client'
import fullObjectivePaymentFragment from './fullObjectivePayment.fragment'

export const ObjectivePaymentByMeeting = gql`
  query ObjectivePaymentByMeeting($meetingId: HashedId!) {
    objectivePaymentByMeeting(id: $meetingId) {
      ...FullObjectivePayment
    }
  }
  ${fullObjectivePaymentFragment}
`

export default {
  ObjectivePaymentByMeeting,
}
